






































import Vue from 'vue';
import Component from 'vue-class-component';
import { Mutation, State, Getter, Action } from 'vuex-class';

import { IProjectLaborType } from '../../models';
import { BaseDetail } from '../Base/BaseDetail';

const namespace = 'projectLaborType';
const ns = { namespace };

@Component
export default class ProjectLaborTypeDetail extends BaseDetail<
  IProjectLaborType
> {
  namespace = namespace;
  @State('entities', ns) entities: Record<string, IProjectLaborType>;
  @Action('createEntity', ns) createEntity: any;
  @Action('getEntity', ns) getEntity: any;
  @Action('updateEntity', ns) updateEntity: any;
  @Action('deleteEntity', ns) deleteEntity: any;
  mounted() {
    this.loadEntity();
  }
}
